import { underscore } from 'inflected';

export default async ({ $api, app, redirect, route, store }) => {
  const coverType = store.getters['products/getCoverType'];
  const search = store.getters['search/get'];
  const i18n = store.$i18n;

  const buildInfo = (plan) => {
    const title = [plan.institution.name, plan.name].join(' ');
    const metaTagOptions = { image: 'insurance', title };
    route.meta[0] = { ...route.meta[0], ...{ metaTagOptions, title } };
    if (route.params.slug) {
      route.meta[0] = { ...route.meta[0], ...{ jumbotronList: jumbotronList(i18n, plan, search), breadcrumbs: breadcrumbs(plan, coverType) } };
    }
  };

  let plan = store.getters['products/get'];
  if (plan && plan.code === route.params.code) {
    buildInfo(plan);
  } else {
    await $api(`protection/${underscore(coverType.product)}_plans/${route.params.code}`).then(plan => {
      if (!plan) {
        return redirect(302,
                        app.localePath(`/${coverType.basePath}/`),
                        { flashClass: 'error', flashMessage: store.$i18n.t('errors.planNotFound') });
      }
      if (plan.slug !== route.params.slug) {
        return redirect(302,
                        app.localePath(`/${coverType.basePath}/${plan.institution.slug}/${plan.code}/${plan.slug}/`));
      }
      buildInfo(plan);
      store.commit('products/set', plan);
    });
  }
};

const breadcrumbs = (plan, coverType) => {
  return [['i18n/home', '/'], ['i18n/insurance', '/insurance/'],
          [`i18n/${coverType.product}`, `/${coverType.basePath}/`],
          ['i18n/providers', `/${coverType.basePath}/providers/`],
          [plan.institution.name, `/${coverType.basePath}/${plan.institution.slug}`, 'mobile'],
          plan.name];
};

const jumbotronList = (i18n, plan, search) => {
  let list = [plan.bonus_benefit_title];
  if (search && search.life1 && plan.quote_premium) {
    list = list.concat([i18n.t('coverAmount', [i18n.n(search.life1, 'currencyRound')]),
                        search.serious_illness ? i18n.t('illnessAmount', [i18n.n(search.illness1, 'currencyRound')]) : null,
                        search.cover_type === 'IP' ? null : i18n.t('term', [i18n.n(search.term)]),
                        i18n.t('lifePremium', [i18n.n(plan.quote_premium, 'currency')])]);
  }
  return list.filter(i => i);
};
